import { useEffect, useState } from "react";
import { Table, Button, Modal } from "antd";
import Lodder from "../../components/Lodder";
import customerServices from "../../services/CustomerService";

const AccountConfiguration = () => {
  const [showLoader, setShowlodder] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [billingDetails, setBillingDetails] = useState();
  const [userName, setUserName] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);

  useEffect(() => {
    document.title = "Account Configuration";
    const name = localStorage.getItem("userName");
    setUserName(name);
    customerServices
      .GetCustomerPaymentHistory()
      .then((response) => {
        if (response.status) {
          setPaymentHistory(response.resultData);
        }
      })
      .finally(() => {
        setShowlodder(false);
      });
    customerServices.GetSubscriptionData().then((response) => {
      if (response.status) {
        console.log(response.resultData);
        setBillingDetails(response.resultData);
      }
    });
  }, []);

  const showModal = (transactionId) => {
    setSelectedTransactionId(transactionId);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    cancelSubscription();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const cancelSubscription = () => {
    setShowlodder(true);
    customerServices
      .CancelSubscription(selectedTransactionId)
      .then((response) => {
        if (response.status) {
          setShowlodder(false);
          customerServices.GetSubscriptionData().then((response) => {
            if (response.status) {
              setBillingDetails(response.resultData);
            }
          });
        }
      });
  };

  return (
    <div
      className="content-wrapper justify-content-center"
      style={{ filter: "grayscale(100%)" }}
    >
      {showLoader && <Lodder />}
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6 mt-5">
              <h1>Account Configuration</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="row mb-4">
              <div className="col-md-3">
                <div className="card w-100">
                  <div className="card-header">
                    <h3 className="card-title">Card Information</h3>
                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        {/* <p className="mb-1">Credit Card - **** **** **** ****</p>
                          <p className="mb-1">Expiry Date - 11/28</p> */}
                        <p className="mb-1">
                          {billingDetails?.card?.brand
                            ? `${billingDetails.card.brand.toUpperCase()} - **** **** **** ${
                                billingDetails.card.last4
                              }`
                            : "Credit Card - **** **** **** ****"}
                        </p>
                        <p className="mb-1">
                          {billingDetails?.card?.expiryMonth &&
                          billingDetails?.card?.expiryYear
                            ? `Expiry Date - ${
                                billingDetails.card.expiryMonth
                              }/${billingDetails.card.expiryYear
                                .toString()
                                .slice(-2)}`
                            : "Expiry Date - **/**"}
                        </p>
                        <p className="mb-0">CVV - ***</p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-end">
                      <Button type="primary" className="my-3 px-5 py-3">
                        Update Card
                      </Button>
                      {/* <Button>Add New</Button> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Account Summary Section */}
              <div className="col-md-9">
                <div className="card h-80 w-100">
                  <div className="card-header">
                    <h3 className="card-title">Account Summary</h3>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <Table
                        columns={[
                          {
                            title: "Account Name",
                            dataIndex: "accountName",
                            key: "accountName",
                            render: () => {
                              return (
                                <>
                                  <span className="">{userName}</span>
                                </>
                              );
                            },
                            sorter: (a, b) =>
                              a.accountName.localeCompare(b.accountName),
                          },
                          {
                            title: "Current Billing Date",
                            dataIndex: "currentBillingDate",
                            key: "currentBillingDate",
                            render: (date) => {
                              return (
                                <>
                                  {new Date(date).toLocaleDateString("en-US", {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                  })}
                                </>
                              );
                            },
                          },
                          {
                            title: "Next Billing Date",
                            dataIndex: "nextBillingDate",
                            key: "nextBillingDate",
                            render: (date) => {
                              return (
                                <>
                                  {new Date(date).toLocaleDateString("en-US", {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                  })}
                                </>
                              );
                            },
                          },
                          {
                            title: "Status",
                            dataIndex: "status",
                            key: "status",
                            sorter: (a, b) => a.status.localeCompare(b.status),
                            render: (status) => {
                              return (
                                <>
                                  <span
                                    className="badge"
                                    style={{
                                      backgroundColor: "gray",
                                      color: "white",
                                      borderRadius: "12px",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {status === "active"
                                      ? "Active"
                                      : "Inactive"}
                                  </span>
                                </>
                              );
                            },
                          },
                        ]}
                        dataSource={[billingDetails]}
                        pagination={false}
                        size="small"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex">
            <div className="col-12 mb-4">
              <div className="card" style={{ width: "100%" }}>
                <div className="card-header">
                  <h3 className="card-title">Active Subscriptions</h3>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <Table
                      columns={[
                        {
                          title: "Subscription Name",
                          dataIndex: "serviceName",
                          key: "serviceName",
                          sorter: (a, b) =>
                            a.serviceName.localeCompare(b.serviceName),
                          render: (text) => {
                            return (
                              <>
                                <span className="">ProSlay {text}</span>
                              </>
                            );
                          },
                          width: "40%",
                        },
                        {
                          title: "Date Started",
                          dataIndex: "date",
                          key: "date",
                          sorter: (a, b) => new Date(a.date) - new Date(b.date),
                          render: (date) => {
                            return (
                              <>
                                {new Date(date).toLocaleDateString("en-US", {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                })}
                              </>
                            );
                          },
                          width: "20%",
                        },
                        {
                          title: "Amount",
                          dataIndex: "amount",
                          key: "amount",
                          sorter: (a, b) => a.amount - b.amount,
                          render: (text) => {
                            return (
                              <>
                                <span className="">${text}.00</span>
                              </>
                            );
                          },
                          width: "20%",
                        },
                        {
                          title: "Actions",
                          dataIndex: "actions",
                          key: "actions",
                          sorter: (a, b) => a.status.localeCompare(b.status),
                          render: (text, record) => {
                            return (
                              <div className="d-flex justify-content-center">
                                {record.status === "active" ? (
                                  <Button
                                    type="primary"
                                    className=""
                                    onClick={() =>
                                      showModal(record.transactionId)
                                    }
                                  >
                                    Cancel my Subscription
                                  </Button>
                                ) : (
                                  <Button
                                    type="primary"
                                    className=""
                                    // onClick={() => renewSubscription(record.transactionId)}
                                  >
                                    Renew Subscription
                                  </Button>
                                )}
                              </div>
                            );
                          },
                          width: "20%",
                        },
                      ]}
                      dataSource={paymentHistory}
                      pagination={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        title="Confirm Cancellation"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>Are you sure you want to cancel your subscription?</p>
      </Modal>
    </div>
  );
};

export default AccountConfiguration;